import ApiManager from '../api/crud-manager';
import utils from '../utils';

class relatedPagesOverview {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="RelatedPagesOverview"]'),
      ...options
    };
    this.apiManager = new ApiManager();
  }

  init() {
    const { moduleList } = this.config;

    if (!moduleList) {
      return;
    }

    moduleList.forEach(module => {
      const { itemsToShow, filterName, filterValue } = module.dataset;

      const element = module;

      if ((filterName, filterValue)) {
        // set parameters
        const parameters = {};
        parameters[`${filterName}`] = filterValue;
        if (itemsToShow != null && Number(itemsToShow) && !Number.isNaN(itemsToShow)) {
          parameters.items = Number(itemsToShow);
        }
        parameters.template = 'pagesOverview';
        const parameterLink = utils.buildApiParameters(parameters);

        element.classList.add('is-loading');

        const url = `/api/v2/page/withProperties${parameterLink}`;
        this.apiManager
          .get(url, 'text/html')
          .then(html => {
            element.innerHTML = html;
            element.classList.remove('is-loading');
          })
          .catch(error => {
            // eslint-disable-next-line no-console
            console.error('related pages overview request failed', error);
            element.classList.remove('is-loading');
            return null;
          });
      }
    });
  }
}

export default relatedPagesOverview;
